import React from 'react'
import { useResume } from './ResumeProvider'
import { useTemplate } from '~/lib/pdf'
import { Button } from '~/lib/ui/button'

const SelectTemplatePanel = () => {
  const { templates } = useTemplate()

  return (
    <div className="h-full ">
      <div className="grid gap-y-4 sm:grid-cols-2 lg:grid-cols-3">
        {templates.map((_, index) => (
          <TemplateOption index={index} key={`template-${index}`} />
        ))}
      </div>
    </div>
  )
}
export default SelectTemplatePanel

const TemplateOption = ({ index }) => {
  const { previewTemplateIndex, setPreviewTemplateIndex } = useResume()
  const { templateIndex, setTemplateIndex } = useTemplate()
  const activeClasses = 'font-roboto-slab text-primary font-bold'
  const inactiveClasses = 'font-roboto-slab text-primary'

  const isPreviewingThis = previewTemplateIndex === index
  const isSelected = templateIndex === index

  const togglePreview = () => {
    if (isPreviewingThis) {
      setPreviewTemplateIndex(null)
    } else {
      setPreviewTemplateIndex(index)
    }
  }

  const handleSelectTemplate = () => {
    setTemplateIndex(index)
    setPreviewTemplateIndex(null)
  }

  return (
    <div className="flex flex-col items-center">
      <div>
        <div className="flex flex-row items-center justify-between px-2 pb-2">
          <span className={isSelected ? activeClasses : inactiveClasses}>
            Style {index + 1}
          </span>
          <Button
            size="sm"
            variant="outline"
            className={isPreviewingThis && 'bg-cod-gray-200'}
            onClick={togglePreview}
            title={`Preview Template ${index + 1}`}
          >
            Preview
          </Button>
        </div>
        <div
          className={
            isSelected
              ? 'relative rounded-xl border-4 border-solid border-primary'
              : 'group relative m-1 rounded-xl'
          }
        >
          <TemplatePreview className="w-48 rounded-xl" templateIndex={index} />
          {!isSelected && (
            <div className="tw-hidden absolute top-0 h-full w-full items-end justify-center pb-4 group-hover:flex">
              <Button onClick={handleSelectTemplate} size="sm">
                Choose Template
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export const TemplatePreview = ({ className, templateIndex }) => {
  const url = `https://www-yns-com.s3.amazonaws.com/resume_builder/Template${templateIndex}.png`
  return (
    <img className={className} src={url} alt={`Template ${templateIndex}`} />
  )
}
